// extracted by mini-css-extract-plugin
export default {"content":"COIRegistryModal_content__o1ohj","body":"COIRegistryModal_body__Lq2YP","fieldRow":"COIRegistryModal_fieldRow__sj+2v"};